import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const CustomizedDialogs = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{width:'30%', paddingRight:'10px'}}>
      {/* <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
      <Typography variant="subtitle2" color="primary" onClick={handleClickOpen} style={{cursor:'pointer', marginLeft:'auto', textAlign:'right'}}>Need Help?</Typography>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
         How to add the YouTube link.
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <strong>Option One: </strong>If you are using YouTube on the web, you can simply copy the URL of your YouTube video and paste it in the form. 
          </Typography>
          <Typography gutterBottom>
          <strong>Option Two: </strong>If you are using the YouTube mobile app, click the share button and click 'Copy Link'. Paste the link in the form.
          </Typography>
          {/* <Typography gutterBottom>
            Simply click 'Copy', and paste the link in the YouTube Link in the input on this page.
          </Typography> */}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CustomizedDialogs;
